import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMainPlans } from '../../actions';
import { Link, withRouter } from 'react-router-dom'

class HowItWorks extends Component {

  renderTeamName(){
    if(this.props.team){
      if(this.props.team.company && this.props.team.company !== ""){
        return this.props.team.company;
      }else{
        return this.props.team.firstname+" "+this.props.team.lastname;
      }
    }
    return "";
  }

  render() {
    if(this.props.copy_tab === "how_it_works"){
      return (
        <div id="how-it-works" className="how-it-works-tab tab-container">

          <div style={{margin: 20, textAlign: "center"}}>
            <h2>Taking Pictures for <b>{this.renderTeamName()}</b> is easy.</h2>
          </div>

          <div className="card flex-item">
            <div className="card-body">
              <div className="feature">
                <div className="feature-text">
                  <p>Anytime you’re in a car, riding your bike, or going for a jog, when you spot a vacant house, just take a picture of it with your smartphone using the DealMachine mobile app</p>
                  <br />
                  <h4><strong>It's that easy.</strong></h4>
                </div>
              </div>

            </div>
          </div>
          <div style={{margin: 20, textAlign: "center"}}>
            <h2>Look for houses that meet any of the following criteria:</h2>
          </div>


          <div className="card flex-item">
            <div className="card-body">
                <div className="feature">
                  <i className="material-icons">markunread_mailbox</i>
                  <div className="feature-text">
                    <h4>Stuffed-full mailbox</h4>
                </div>
              </div>
            </div>
          <div className="card-body">
            <div className="feature">
              <i className="material-icons">broken_image</i>
                <div className="feature-text">
                  <h4>Broken or boarded up windows</h4>
                </div>
              </div>
            </div>


          <div className="card-body">
            <div className="feature">
                <i className="material-icons">home</i>
                <div className="feature-text">
                  <h4>Tarp on the roof or falling-off gutters</h4>
                </div>
              </div>
          </div>

          <div className="card-body">
            <div className="feature">
              <i className="fa fa-eye"></i>
                <div className="feature-text">
                  <h4>Visually in bad shape</h4>
                </div>
              </div>
          </div>
          <div className="card-body">
            <div className="feature">
                <i className="fa fa-snowflake"></i>
                <div className="feature-text">
                  <h4>Snow fell but there are no tire tracks or footprints on the driveway</h4>
                </div>
              </div>
          </div>

          <div className="card-body">
            <div className="feature">
              <i className="fab fa-pagelines"></i>
                <div className="feature-text">
                  <h4>Tall grass</h4>
                </div>
              </div>
          </div>



        </div>


        <div style={{margin: 20, marginBottom:60, textAlign: "center"}}>
            <h2>Start Earning Today</h2>
            <p><a href={'tel:'+this.props.team.phone}>{this.props.team.phone}</a></p>
            <p>This offer is provided by <b>{this.renderTeamName()}</b>, who will provide you with access to DealMachine, the mobile app you’ll use to take pictures. <b>{this.renderTeamName()}</b> will provide you with a partner contract, and will be the party responsible for paying you.</p>
          </div>

        </div>
      );
    }else{
      return <div />;
    }
  }
};

const mapStateToProps = ({ auth }) => {
  const { copy_tab, team, plans, plans_loading, plans_error, signup_type, signup_team_name, signup_team_company } = auth;
  return { copy_tab, team, plans, plans_loading, plans_error, signup_type, signup_team_name, signup_team_company }
}

export default withRouter(connect(mapStateToProps, {})(HowItWorks));



// WEBPACK FOOTER //
// ./src/components/GetStarted/HowItWorks.js